import { ANALYTICS_SITE } from "../const/config";

const isReady = () => {
    return typeof window !== "undefined" && typeof window.fbq === "function";
};

const getDeviceInfo = () => {
    if (typeof navigator === "undefined") return {};

    const ua = navigator.userAgent.toLowerCase();

    let device = "desktop";
    let os = "unknown";

    if (/android/.test(ua)) {
        device = "mobile";
        os = "android";
    } else if (/iphone|ipad|ipod/.test(ua)) {
        device = "mobile";
        os = "ios";
    }

    return {
        device,
        os,
        user_agent: ua,
    };
};

const track = (event, payload = {}, isCustom = false) => {
    if (!isReady()) return;

    try {
        const {
            content_name,
            category,
            ...rest
        } = payload;

        const data = {
            site: ANALYTICS_SITE,
            ...getDeviceInfo(),
            ...rest,

            content_name: `${ANALYTICS_SITE}_${content_name || "unknown"}`,
            content_category: category || "general",

            // Meta chuẩn
            content_type: "product",
        };

        const method = isCustom ? "trackCustom" : "track";

        window.fbq(method, event, data);
    } catch (err) {
        console.error(`[FacebookPixel] Failed to track event "${event}":`, err);
    }
};

export const trackPage = (page) => {
    if (!isReady()) return;

    window.fbq("track", "PageView");

    track(
        "PageVisit",
        {
            content_name: `page_${page}`,
            category: "page",
            page,
        },
        true
    );
};

export const trackDownload = (platform, method) => {
    track("Lead", {
        content_name: `download_${platform}_${method}`,
        category: "download",
        platform,
        method,
    });
};

export const trackSocial = (network) => {
    track("Contact", {
        content_name: `social_${network}`,
        category: "social",
        network,
    });
};

export const trackGuide = (platform) => {
    track("ViewContent", {
        content_name: `guide_${platform}`,
        category: "guide",
        platform,
    });
};


export const trackInstallFlow = (
    platform,
    action,
    tab = null
) => {
    track(
        "InstallFlow",
        {
            content_name: `install_${platform}_${action}`,
            category: "install",
            platform,
            action,
            ...(tab !== null && { tab }),
        },
        true
    );
};

const facebookPixel = {
    trackPage,
    trackDownload,
    trackSocial,
    trackGuide,
    trackInstallFlow,
};

export default facebookPixel;
